import {UserAuthenticationBaseRequestDto, UserAuthenticationBaseResponseDto} from './user-authentication-base.dto';
import {AutoMap} from '@automapper/classes';

export class GoogleSsoRequestDto extends UserAuthenticationBaseRequestDto {
  @AutoMap()
  public token!: string;
}

export class GoogleSsoResponseDto extends UserAuthenticationBaseResponseDto {

}
